import { useSelector } from 'react-redux';
import AdditionalSubscriptionRow from './AdditionalSubscriptionRow';
import { Account, OrganizationFeature } from '../../../../models';
import {
  fromTestCloudSubscriptions,
  useAppDispatch,
} from '../../../../store';
import { getTestCloudFreeTrialExpiryDate } from '../../../subscription-management/utils';
import { useConfig } from '../../../../config';

export interface TestCloudSubscriptionDetailsProps{
  account: Account | null,
  email: string | null,
  organizationId: number,
}

const TestCloudSubscriptionDetails = (props: TestCloudSubscriptionDetailsProps) => {
  const {
    account,
    organizationId,
    email,
  } = props;
  const dispatch = useAppDispatch();
  const { config } = useConfig();

  const testCloudTrialDate = getTestCloudFreeTrialExpiryDate(
    config,
    account?.createdAt,
  );

  const hasTestCloudSubscriptions = useSelector(
    fromTestCloudSubscriptions.selectByAccountId(
      Number(account?.id),
    ),
  ).length !== 0;

  const currentActiveTestCloudSubscription = useSelector(
    fromTestCloudSubscriptions.selectActiveByAccountId(
      Number(account?.id),
    ),
  )?.[0];

  const handleRefreshSubscription = async () => {
    await Promise.all([
      dispatch(fromTestCloudSubscriptions.doGetActiveByAccountId({
        accountId: Number(account?.id),
      })),
    ]);
  };

  const isTestCloudFreeTrialValid = new Date().valueOf() < testCloudTrialDate
    && !hasTestCloudSubscriptions;

  const name = currentActiveTestCloudSubscription
    ? 'subscriptions.test_cloud'
    : 'subscriptions.test_cloud_trial';

  return (
    (currentActiveTestCloudSubscription || isTestCloudFreeTrialValid)
      ? (
        <AdditionalSubscriptionRow
          key={name}
          name={name}
          organizationId={organizationId}
          email={email}
          currentSubscription={currentActiveTestCloudSubscription}
          initQuantity={5}
          feature={OrganizationFeature.TESTCLOUD_SESSION_WEB}
          trialExpiryDate={testCloudTrialDate}
          handleRefreshSubscription={handleRefreshSubscription}
        />
      ) : null
  );
};

export default TestCloudSubscriptionDetails;
